/**
 * variant-supply-updater.js
 * Recalculates day supply and per-day price when variant pills are clicked.
 * Works on both product pages and collection cards.
 *
 * Logic:
 *   base variant: supply = "90 capsules", day_supply = 45
 *   dose_per_day = 90 / 45 = 2
 *   user selects "250 caps" variant:
 *   new_day_supply = 250 / 2 = 125
 *   new_per_day = new_price / 125
 *
 * Unit normalisation: all weights converted to grams, volumes to ml,
 * before division — prevents cross-unit errors (e.g. 1kg vs 500g).
 *
 * Hooks into Udesly pill click system — runs after Udesly updates the price.
 */
(function () {
  'use strict';

  /**
   * Parses a quantity string like "500g", "1kg", "90 capsules", "500 ml".
   * Returns { value: Number, unit: String }.
   */
  function parseQuantity(text) {
    var m = text.trim().match(/^(\d+(?:\.\d+)?)\s*(kg|g|ml|l|capsules?|caps?|tabs?|tablets?|softgels?|sachets?|patches?|gummies?|drops?)?/i);
    if (!m) return { value: parseFloat(text), unit: '' };
    return { value: parseFloat(m[1]), unit: (m[2] || '').toLowerCase() };
  }

  /**
   * Converts a parsed quantity to its base unit (g for weight, ml for volume).
   * Capsules and other countables are returned as-is.
   */
  function toBaseUnit(value, unit) {
    if (unit === 'kg') return value * 1000;
    if (unit === 'l')  return value * 1000;
    return value;
  }

  function initCard(card) {
    var daySupplyEl = card.querySelector('.daySupply');
    if (!daySupplyEl) return;

    var baseDaySupply = parseFloat(daySupplyEl.textContent);
    if (!baseDaySupply || isNaN(baseDaySupply)) return;

    var supplyTextEl = null;
    var priceWrap = card.querySelector('.product_price-wrap');
    if (priceWrap) {
      var divs = priceWrap.querySelectorAll('div');
      for (var i = 0; i < divs.length; i++) {
        var txt = divs[i].textContent.trim();
        if (divs[i].querySelector('.daySupply')) continue;
        if (divs[i].classList.contains('product-card_splitter')) continue;
        var match = txt.match(/^(\d+)\s*(.+)$/);
        if (match) {
          supplyTextEl = divs[i];
          break;
        }
      }
    }

    var baseNormalised = null;
    if (supplyTextEl) {
      var baseParsed = parseQuantity(supplyTextEl.textContent.trim());
      if (!isNaN(baseParsed.value) && baseParsed.value > 0) {
        baseNormalised = toBaseUnit(baseParsed.value, baseParsed.unit);
      }
    }

    if (!baseNormalised) {
      var activePill = card.querySelector('.w-commerce-commerceaddtocartoptionpill.w--current, .w-commerce-commerceaddtocartoptionpill[aria-pressed="true"]');
      if (!activePill) {
        activePill = card.querySelector('.w-commerce-commerceaddtocartoptionpill');
      }
      if (activePill) {
        var fallback = parseQuantity(activePill.textContent.trim());
        if (!isNaN(fallback.value) && fallback.value > 0) {
          baseNormalised = toBaseUnit(fallback.value, fallback.unit);
        }
      }
    }

    if (!baseNormalised || isNaN(baseNormalised)) return;

    var dosePerDay = baseNormalised / baseDaySupply;

    var pillGroup = card.querySelector('.w-commerce-commerceaddtocartoptionpillgroup');
    if (!pillGroup) return;

    pillGroup.addEventListener('click', function (e) {
      var pill = e.target.closest('.w-commerce-commerceaddtocartoptionpill');
      if (!pill) return;

      var pillParsed = parseQuantity(pill.textContent.trim());
      if (isNaN(pillParsed.value)) return;

      var newNormalised = toBaseUnit(pillParsed.value, pillParsed.unit);
      var newDaySupply = Math.round(newNormalised / dosePerDay);

      daySupplyEl.textContent = newDaySupply;

      if (supplyTextEl) {
        supplyTextEl.textContent = pill.textContent.trim();
      }

      setTimeout(function () {
        var priceEl = card.querySelector('.pricePerItem');
        var perDayEl = card.querySelector('.pricePerDay');
        if (priceEl && perDayEl && newDaySupply > 0) {
          var priceText = priceEl.textContent.trim();
          var currSymbolMatch = priceText.match(/^[^\d,]+/);
          var currSymbol = currSymbolMatch ? currSymbolMatch[0].trim() : '';
          var numericText = priceText.replace(currSymbol, '').trim().replace(',', '.');
          numericText = numericText.replace(/[^\d.-]/g, '');
          if (numericText[0] === '.' || numericText[0] === ',') {
            numericText = numericText.substring(1);
          }
          var price = parseFloat(numericText);
          if (!isNaN(price)) {
            var perDay = price / newDaySupply;
            perDayEl.textContent = currSymbol + perDay.toFixed(2);
          }
        }
      }, 150);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productHeader = document.querySelector('.cc-product-header .product_info_col');
    if (productHeader) {
      initCard(productHeader);
    }

    var cards = document.querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      initCard(cards[i]);
    }
  });
})();